export const education = [
  {
    id: 'westcliff',
    degree: 'MBA',
    track: 'Professional Format',
    institution: 'Westcliff University',
    period: 'In Progress',
    location: 'Irvine, CA',
  },
  {
    id: 'uab',
    degree: 'MS, Data Science',
    institution: 'University of Alabama at Birmingham',
    period: 'Jun 2021',
    location: 'Birmingham, AL',
    gpa: '4.00 / 4.00',
  },
  {
    id: 'vit',
    degree: 'BTech, Computer Science Engineering',
    institution: 'Vellore Institute of Technology',
    period: '2015 — 2019',
    location: 'Vellore, India',
    gpa: '7.71 / 10',
  },
];
